import {Routes, Route} from 'react-router-dom'

import {publicRoutes} from './routes';

function index() {
  return (
        <Routes>
            <Route>
                {publicRoutes.map((item,idx)=>(
                    <Route path={item.path} element={item.component} key={idx}/>
                ))}
            </Route>
        </Routes>
  )
}

export default index